import React, { useState } from 'react';
import { ROLE_LABELS } from '../../utils/permissions';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LogoutModal from '../Layout/LogoutModal';
import useTheme from '../../hooks/useTheme';

/* ── SVG icons ── */
const IcHome = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
    <polyline points="9 22 9 12 15 12 15 22"/>
  </svg>
);
const IcUsers = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);
const IcBook = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
  </svg>
);
const IcEdit = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
  </svg>
);
const IcChart = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="20" x2="18" y2="10"/>
    <line x1="12" y1="20" x2="12" y2="4"/>
    <line x1="6" y1="20" x2="6" y2="14"/>
    <line x1="2" y1="20" x2="22" y2="20"/>
  </svg>
);
const IcClipboard = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/>
    <rect x="9" y="3" width="6" height="4" rx="2"/>
    <line x1="9" y1="12" x2="15" y2="12"/><line x1="9" y1="16" x2="12" y2="16"/>
  </svg>
);
const IcInbox = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="22 12 16 12 14 15 10 15 8 12 2 12"/>
    <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/>
  </svg>
);
// «Сотрудники» — бейдж-планшет с человечком (как на скрине)
const IcBadge = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="4" y="4" width="16" height="17" rx="2.5"/>
    <rect x="9" y="2.5" width="6" height="3" rx="1.2"/>
    <circle cx="12" cy="11" r="2.3"/>
    <path d="M8.2 17.4c0-2.1 1.7-3.5 3.8-3.5s3.8 1.4 3.8 3.5"/>
  </svg>
);
// «Доступы» — ключ: до какого дня у ученика открыт доступ
const IcKey = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z"/>
    <circle cx="16.5" cy="7.5" r=".5" fill="currentColor"/>
  </svg>
);
// «Профиль» — один человек (у «Учеников» иконка на двоих, у «Сотрудников» — бейдж)
const IcUser = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
    <circle cx="12" cy="7" r="4"/>
  </svg>
);
const IcLogout = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
    <polyline points="16 17 21 12 16 7"/>
    <line x1="21" y1="12" x2="9" y2="12"/>
  </svg>
);
const IcMoon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
  </svg>
);
const IcMenu = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/>
  </svg>
);
const IcSun = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/>
    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
    <line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/>
    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
  </svg>
);

// Разделы/уроки/задания/варианты переехали внутрь курса (открывается с «Главной»).
/* Разделы/уроки/задания/варианты переехали внутрь курса (открывается с «Главной»).
   `perm` — право, без которого пункт не показываем: менеджер не проверяет ДЗ,
   сотрудники доступны только главному администратору. */
const NAV_ITEMS = [
  { to: '/admin/dashboard',   Icon: IcHome,   label: 'Главная' },
  { to: '/admin/students',    Icon: IcUsers,  label: 'Ученики' },
  { to: '/admin/progress',    Icon: IcChart,  label: 'Статистика' },
  { to: '/admin/access',      Icon: IcKey,    label: 'Доступы' },
  { to: '/admin/review',      Icon: IcInbox,  label: 'Проверка ДЗ', perm: 'homework.review' },
  { to: '/admin/staff',       Icon: IcBadge,  label: 'Сотрудники', perm: 'staff.view' },
  { to: '/admin/profile',     Icon: IcUser,   label: 'Профиль' },
];

const Sidebar = ({ isOpen }) => {
  const { user, logout, can } = useAuth();
  const navigate = useNavigate();
  const [logoutOpen, setLogoutOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem('a_sidebar_collapsed') === '1');
  const { dark, toggle } = useTheme();

  const toggleCollapse = () => setCollapsed(c => {
    localStorage.setItem('a_sidebar_collapsed', !c ? '1' : '0');
    return !c;
  });

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const ASSET = `${process.env.PUBLIC_URL || ''}/landing`;

  return (
    <div className={`sidebar${isOpen ? ' sidebar--open' : ''}${collapsed ? ' collapsed' : ''}`}>
      {/* Декоративные слои: текстура кода + свечение */}
      <div className="sb-code" style={{ backgroundImage: `url(${ASSET}/pattern-brand.png)` }} />
      <div className="sb-glow" />

      {/* Brand */}
      <div className="sidebar-brand">
        <div className="sb-brand-top">
          <div className="sb-logo-box">
            <img className="sb-logo-img" src={`${ASSET}/logo-hq.png`} alt="ИНФА СОТКА" />
            <img className="sb-logo-mark" src={`${ASSET}/logo-mark.png`} alt="" aria-hidden="true" />
          </div>
          {/* кнопка «свернуть» — рядом с лого, видна только когда сайдбар открыт */}
          <button className="sb-collapse-btn" onClick={toggleCollapse} aria-label="Свернуть меню" title="Свернуть меню">
            <IcMenu />
          </button>
        </div>
        {/* Ряд 2 постоянной высоты: текст (открыто, плавно) ИЛИ кнопка-открыть (закрыто) */}
        <div className="sb-brand-row2">
          {collapsed ? (
            <button className="sb-open-btn" onClick={toggleCollapse} aria-label="Развернуть меню" title="Развернуть меню">
              <IcMenu />
            </button>
          ) : (
            <div className="sidebar-brand-subtitle">{ROLE_LABELS[user?.role] || user?.roleTitle || 'Сотрудник'}</div>
          )}
        </div>
      </div>

      {/* Admin profile — клик ведёт в профиль */}
      <div className="admin-profile admin-profile--link" onClick={() => navigate('/admin/profile')} title="Открыть профиль">
        <div className="admin-avatar">
          {user?.avatar
            ? <img src={user.avatar} alt="" />
            : (user?.name ? user.name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2) : 'А')}
        </div>
        <div className="admin-info">
          <h4>{user?.name || 'Администратор'}</h4>
          <p>{user?.email}</p>
        </div>
      </div>

      {/* Nav */}
      <ul className="nav-menu">
        {NAV_ITEMS.filter(item => !item.perm || can(item.perm)).map((item) => (
          <li key={item.to} className="nav-item">
            <NavLink
              to={item.to}
              title={item.label}
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
            >
              <span className="nav-icon"><item.Icon /></span>
              <span>{item.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>

      {/* Footer */}
      <div className="sidebar-footer">
        <button className="sb-theme" onClick={toggle} title={dark ? 'Светлая тема' : 'Тёмная тема'}>
          <span className="nav-icon">{dark ? <IcSun /> : <IcMoon />}</span>
          <span>{dark ? 'Светлая тема' : 'Тёмная тема'}</span>
        </button>
        <button className="sidebar-logout-btn" onClick={() => setLogoutOpen(true)} title="Выйти">
          <span className="nav-icon"><IcLogout /></span>
          <span>Выйти</span>
        </button>
      </div>

      <LogoutModal open={logoutOpen} onClose={() => setLogoutOpen(false)} onConfirm={handleLogout} />
    </div>
  );
};

export default Sidebar;
